import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { promises } from 'fs';
import { promise } from 'protractor';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Paginations {
  data: [];
  total: number;
  current_page: number;
  from: number;
  last_page: number;
  per_page: number;
  to: number;
}

@Injectable({
  providedIn: 'root',
})
export class TalentService { 
  constructor(private http: HttpClient) {}

  // tslint:disable-next-line: typedef
  getCountry() {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/address/get_country`).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/address/get_country`);
  }

  // tslint:disable-next-line: typedef
  getCountryRegion(id) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/address/get_region/` + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/address/get_region/` + id);
  }

  // tslint:disable-next-line: typedef
  getCountryState(id, rgnID) {
    return new Promise((resolve) => {
      this.http
        .get(`${environment.apiUrl}/address/get_states/` + id + '/' + rgnID)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });

    // return this.http.get<any[]>(`${environment.apiUrl}/address/get_states/` + id);
  }

  // tslint:disable-next-line: typedef
  getCountryDivision(id) {
    return new Promise((resolve) => {
      this.http
        .get(`${environment.apiUrl}/address/get_divisions/` + id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/address/get_divisions/` + id);
  }

  // tslint:disable-next-line: typedef
  getCountryCity(id, dvsnID) {
    return new Promise((resolve) => {
      this.http
        .get(`${environment.apiUrl}/address/get_city/` + id + '/' + dvsnID)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
  }

  // tslint:disable-next-line: typedef
  getCountryPincode(id) {
    return new Promise((resolve) => {
      this.http
        .get(`${environment.apiUrl}/address/get_pincode/` + id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/address/get_pincode/` + id);
  }
  getMrfOptions(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_mrf_options`);
  }
  addMrf(req: FormData, mrfId: string): Observable<any[]> {
    if (mrfId == null || mrfId === '' || mrfId === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/add_mrf`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/edit_mrf_action`,
        req
      );
    }
  }
  cloneMrf(req: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/clone_mrf`,
      req
    );
  }

  getMrfs(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    // if ('sort' in data && data.sort !== '' && data.sort !== undefined){
    //   param = param.append('sort', data.sort);
    // }

    // if ('direction' in data && data.direction !== '' && data.direction !== undefined) {
    //   param = param.append('direction', data.direction);
    // }

    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any>(`${environment.apiUrl}/talent/mrf/get_mrfs`, {
      params: param,
    });
  }
  getMrfsStackHolders(data): Observable<any> {
    let param = new HttpParams();
    // for (const key in data.forms) {
    //   if (data.forms[key] !== '' && data.forms[key] !== undefined && data.forms[key] !== null) {
    //     param = param.append(key, data.forms[key]);
    //   }
    // }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any>(
      `${environment.apiUrl}/talent/mrf/get_mrfs_holders`,
      { params: param }
    );
  }
  deleteMrf(mrfId: string): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_mrf/` + mrfId
    );
  }
  deleteMrfFile(mrfId: string): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_mrf_file/` + mrfId
    );
  }
  holdMrf(req: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/hold_mrf` ,req
    );
  }
  unHoldMrf(req: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/un_hold_mrf` , req
    );
  }
  getHoldDetails(id: any ): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/talent/mrf/get_hold_details/` + id
    );
  }
  editMrf(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_mrf/` + mrfId
    );
  }

  getIjpMrfsRegular(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_ijp_mrfs`,
      { params: param }
    );
  }
  getIjpMrfsFTC(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_ijp_mrfs_ftc`,
      { params: param }
    );
  }
  getIjpDetails(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_ijp_details/` + mrfId
    );
  }
  getMrfDetails(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_details/` + mrfId
    );
  }
  getCandiateSource(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_candidate_source_list`
    );
  }
  getCandiateSubSource(dpId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_candidate_sub_source_list/` + dpId
    );
  }
  deleteCandEval(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_cand_eval`,
      req
    );
  }
  assignMrf(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/assign_mrf`,
      req
    );
  }
  getMrfCandidates(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_cand/` + mrfId
    );
  }
  getMrfCandidatesList(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_cand_list/` + mrfId
    );
  }
  getMrfTransferCandidatesList(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_trasnfer_cand_list/` + mrfId
    );
  }
  addCandidatetransfer(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_transfer`,
      data
    );
  }
  addCandidate(req, candID): Observable<any[]> {
    if (candID === '' || candID === null || candID === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/add_cand`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_cand`,
      req
    );
  }

  deleteCandidate(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_cand`,
      params
    );
  }
  getCandidate(candId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_cand/` + candId
    );
  }
  jobApply(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/ijp_apply`,
      req
    );
  }
  candidateDetails(candId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_cand_detail/` + candId
    );
  }
  updateCandStage(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/update_cand_stage`,
      req
    );
  }
  addCandEval(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_eval`,
      req
    );
  }
  getCandDetailOffer(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_cand_detail_offer/` + candID
    );
  }
  getCandPayrollStructure(
    candID,
    type,
    rest = '',
    skill = '0'
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_salary_structure/` +
        candID +
        `/` +
        type +
        `/` +
        rest +
        '/' +
        skill
    );
  }
  addCandOffer(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_offer`,
      req
    );
  }
  appointCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_appoint`,
      req
    );
  }
  joinCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_joined`,
      req
    );
  }
  rejectCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_reject`,
      req
    );
  }
  candTransferRejectRemark(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/cand_transfer_reject`,
      req
    );
  }
  transferEmployee(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_employee_transfer`,
      req
    );
  }
  generatetransferletter(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/generate_transfer_letter`,
      req
    );
  }

  editCandAddress(addID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_cand_add/` + addID
    );
  }
  editCandAddressAction(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_cand_add_action`,
      req
    );
  }
  removeFile(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_cand_file_action`,
      req
    );
  }

  getInternalJobsFilter(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_jobs_filter`);
  }

  getStateForFilter(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_state_name`);
  }
  getRegion(cnId): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_region/` + cnId);
  }
  getEmpOrgCountryId(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_emp_logged_country`);
  }

  getCityForFilter(stId): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_city_name/` + stId);
  }

  getEmpSkill(typeId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_emp_skill/` + typeId
    );
  }
  addEmpSkill(req: any, typeId: string, emId: any): Observable<any[]> {
    if (emId === '' || emId === null || emId === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/add_skill_action`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_skill_action`,
      req
    );
  }
  editEmpSkill(id): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_skill/` + id
    );
  }
  deleteEmpSkill(id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_skill/` + id
    );
  }

  getOrgDesign(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_org_designation`
    );
  }
  getOrgCity(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_org_city`
    );
  }
  getEmpJobs(typeId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_emp_jobs/` + typeId
    );
  }
  addEmpJobs(req: any, typeId: string): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_jobs_action`,
      req
    );
  }
  deleteEmpJobs(id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_jobs/` + id
    );
  }

  // JD Repos

  addJD(req, editID): Observable<any> {
    if (!editID) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/jd_rep_action`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/edit_jd_rep_action`,
        req
      );
    }
  }

  getRepo(data): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/get_repository`,
      data
    );
  }

  editJdRepo(jdID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_jd_repository/${jdID}`
    );
  }

  editJdRepoStatus(stat, jdID): Observable<any> {
    const option = {
      status: stat,
      id: jdID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_jd_rep_status`,
      options
    );
  }

  getjdRepo(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_jd_repository`
    );
  }

  deleteJDRepo(jdID): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_jd_repository`,
      { id: jdID }
    );
  }

  getCandidateDetails(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_candidate`,
      req
    );
  }

  // addCandidateIJP(req, candID): Observable<any[]> {
  //   if (candID === '' || candID === null || candID === undefined){
  //     return this.http.post<any[]>(`${environment.apiUrl}/talent/mrf/cand_apply_ijp`, req);
  //   }
  //   // return this.http.post<any[]>(`${environment.apiUrl}/talent/mrf/edit_cand`, req);
  // }
  addCandidateIJP(req, candID): Observable<any[]> {
    if (candID === '' || candID === null || candID === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/cand_ijp_apply`,
        req
      );
    }
  }

  getMrfTransferDetails(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_transfer_details/` + mrfId
    );
  }
  getEmployeesDetails(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/employee/get_emp_details_ijp`
    );
  }
  addTransfer(req: FormData, mrfId: string): Observable<any[]> {
    if (mrfId == null || mrfId === '' || mrfId === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/add_transfer`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/edit_transfer_action`,
        req
      );
    }
  }
  // if (mrfId == null || mrfId === '' || mrfId === undefined){
  //   return this.http.post<any[]>(`${environment.apiUrl}/talent/mrf/add_mrf`, req);
  // }else{
  //   return this.http.post<any[]>(`${environment.apiUrl}/talent/mrf/edit_mrf_action`, req);
  // }

  addMrfTransferCand(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_mrf_transfer_cand`,
      req
    );
  }
  getTransferCandDetails(CandID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_transfer_cand_details/` + CandID
    );
  }

  // checkLists

  getCheckList(type): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/options/get_checklist?type=${type}`
    );
  }

  deleteChecklist(chkID): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/setups/options/delete_checklist/` + chkID
    );
  }

  editCheckList(chkID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/options/edit_checklist/` + chkID
    );
  }

  editChecklistStatus(stat, chkID): Observable<any> {
    const option = {
      status: stat,
      chklist_id: chkID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/options/edit_chklist_status_action`,
      options
    );
  }

  addChecklist(data: FormData, chkID): Observable<any> {
    if (!chkID) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/options/add_onoff_brd_chklst`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/options/edit_chklist_action`,
        data
      );
    }
  }

  getDepartment(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_departments`);
  }
  getCategory(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options_mod/` + ID);
  }

  getOffBoardChecklist(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/off_board_checklist`,
      req
    );
  }

  updateExtendDate(req): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/off_board_extend_warranty`,
      req
    );
  }
  getExitApprovals(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_exit_emps`
    );
  }
  employeeOffBoardingCompleted(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/employee_offboard_completed`,
      req
    );
  }
  rejectEmp(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/reject_employee`,
      req
    );
  }
  approveEmpExit(data: FormData): Observable<any[]> {
    // if (!chkId) {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/approve_employee_request`,
      data
    );
    // }
  }
  saveEmpExitChklist(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/save_employee_chklist`,
      data
    );
  }

  updateExtendDateCand(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/extend_cand_date`,
      req
    );
  }
  updateCandMediclaim(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/mediclaim_for_regular`,
      req
    );
  }

  extendTransferDate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/extend_transfer_date`,
      req
    );
  }
  candLookup(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/cand_lookup`,
      req
    );
  }
  getONBoardChecklist(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/on_board_checklist`,
      req
    );
  }

  addCandidateChklist(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_chklist`,
      data
    );
  }

  addCandidateChklistRegular(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_chklist_regular`,
      data
    );
  }
  mrfNotRequired(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/mrf_not_required`,
      params
    );
  }

  getHiringType(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_hireing_type/` + ID);
  }
  getSalaryType(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options_mod/` + ID);
  }
  addCandidateFinance(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/add_cand_finance`,
      data
    );
  }

  getBankAccount(ID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_options/` + ID);
  }
  candUpdateStage(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/update_cand_stage`,
      params
    );
  }

  editMrfForm(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/edit_transfer/` + mrfId
    );
  }
  getMRFSLA(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_sla`,
      params
    );
  }
  assignBulkMrf(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/assign_bulk_mrf`,
      req
    );
  }
  getTeamMember(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_assign_team`
    );
  }
  getMrfApproverDetails(ID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_approver_details/` + ID
    );
  }
  getCandFinanceDetails(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_cand_finance_details/` + candID
    );
  }
  finishFTCChklist(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/check_cand_checklist_status/` + candID
    );
  }
  finishRegularChklist(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/check_cand_checklist_status/` + candID
    );
  }
  getMyAppStatus(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_app_status`
    );
  }

  getSkillsForApproval(typeId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_skills_approval/` + typeId
    );
  }
  addSkillsApproval(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/skills_approval_action`,
      req
    );
  }

  // getMrfOfferCandidates(ccID): Observable<any[]> {
  //   return this.http.get<any[]>(`${environment.apiUrl}/talent/mrf/get_offered_candidates?cc_id=${ccID}`);
  // }
  getMrfOfferCandidates(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_offered_candidates`,
      { params: param }
    );
  }
  getTransferCandidates(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_transfer_candidates`,
      { params: param }
    );
  }

  createExitEmployeeMrf(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/create_mrf_exit_employee`,
      req
    );
  }

  addConfig(data, configEditId): Observable<any> {
    if (!configEditId) {
      return this.http.post<any>(
        `${environment.apiUrl}/talent/mrf/add_mrf_config`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/talent/mrf/edit_mrf_config_action`,
        data
      );
    }
  }

  configurationGet(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_mrf_config`,
      { params: param }
    );
  }

  editMrfConfig(ID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/talent/mrf/edit_mrf_config/` + ID
    );
  }

  // naps

  getNapsTeamMember(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_assign_team`
    );
  }
  addNApsMrf(req: FormData, mrfId: string): Observable<any[]> {
    if (mrfId == null || mrfId === '' || mrfId === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/naps/add_naps_mrf`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/naps/edit_naps_mrf_action`,
        req
      );
    }
  }

  getNapsMrfs(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any>(
      `${environment.apiUrl}/talent/naps/get_naps_mrf`,
      { params: param }
    );
  }

  napsMrfNotRequired(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/naps_mrf_not_required`,
      params
    );
  }
  assignBulkNAPSMrf(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/assign_bulk_naps_mrf`,
      req
    );
  }
  getNapsMrfDetails(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_mrf_details/` + mrfId
    );
  }

  editNapsMrf(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/edit_naps_mrf/` + mrfId
    );
  }

  getNapsMrfCandidatesList(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_mrf_cand_list/` + mrfId
    );
  }

  addNapsCandidate(req, candID): Observable<any[]> {
    if (candID === '' || candID === null || candID === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/naps/add_naps_cand`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/edit_naps_cand`,
      req
    );
  }

  napsCandidateDetails(candId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_mrf_cand_detail/` + candId
    );
  }

  getNapsCandidate(candId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_cand/` + candId
    );
  }

  deleteNapsCandidate(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/delete_naps_cand`,
      params
    );
  }

  getNapsCandDetailAppoint(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_mrf_cand_detail_appoint/` +
        candID
    );
  }

  addNapsCandAppoint(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/add_naps_cand_appoint`,
      req
    );
  }
  getNapsNewJoiningList(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_naps_joining_data`
    );
  }

  getAplDetails(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/view_apl_detail`,
      { params: param }
    );
  }

  getAplReport(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/talent/naps/download_naps_npl`
    );
  }

  updateCandDetails(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/upload_cand_details`,
      data
    );
  }

  getNapsCandiateSource(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/get_candidate_source`
    );
  }

  getONBoardChecklistNaps(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/on_board_checklist_naps`,
      req
    );
  }
  addNAPSCandidateChklist(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/add_naps_cand_chklist`,
      data
    );
  }
  finishNapsChklist(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/check_naps_cand_checklist_status/` +
        candID
    );
  }
  rejectNapsCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/add_naps_cand_reject`,
      req
    );
  }
  joinNapsCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/add_naps_cand_joined`,
      req
    );
  }
  downloadNapsMRFReport(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/naps/download_naps_mrf_report`
    );
  }

  addNapsCandEval(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/add_naps_cand_eval`,
      req
    );
  }

  addNapsCandidateFinance(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/naps/add_naps_cand_finance`,
      data
    );
  }

  //candidate databse
  getCandidateStage(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_cand_stage`
    );
  }
  getCandDataBase(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_cand_database`,
      { params: param }
    );
  }

  addCandidateMGMT(req, candID): Observable<any[]> {
    if (candID === '' || candID === null || candID === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/mrf/add_candidate`,
        req
      );
    }
    // return this.http.post<any[]>(
    //   `${environment.apiUrl}/talent/mrf/edit_cand`,
    //   req
    // );
  }

  assignCandMrf(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/talent/mrf/add_assign_mrf`,
      req
    );
  }

  getSuggestionCandidate(mrfId): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/talent/mrf/get_suggestion_cand/` + mrfId
    );
  }

  // Intern
  addInternMrf(req: FormData, mrfId: string): Observable<any[]> {
    if (mrfId == null || mrfId === '' || mrfId === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/intern/add_intern_mrf`,
        req
      );
    } else {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/intern/edit_intern_mrf_action`,
        req
      );
    }
  }

  getInternMrfs(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms[key] !== '' &&
        data.forms[key] !== undefined &&
        data.forms[key] !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    // if ('sort' in data && data.sort !== '' && data.sort !== undefined){
    //   param = param.append('sort', data.sort);
    // }

    // if ('direction' in data && data.direction !== '' && data.direction !== undefined) {
    //   param = param.append('direction', data.direction);
    // }

    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any>(
      `${environment.apiUrl}/talent/intern/get_intern_mrf`,
      { params: param }
    );
  }

  getInternMrfDetails(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_mrf_details/` + mrfId
    );
  }

  editInternMrf(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/edit_intern_mrf/` + mrfId
    );
  }

  deleteInternMrf(mrfId: string): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/talent/mrf/delete_intern_mrf/` + mrfId
    );
  }

  getInternMrfCandidatesList(mrfId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_mrf_cand_list/` + mrfId
    );
  }

  addInternCandidate(req, candID): Observable<any[]> {
    if (candID === '' || candID === null || candID === undefined) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/talent/intern/add_intern_cand`,
        req
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/edit_intern_cand`,
      req
    );
  }

  internCandidateDetails(candId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_mrf_cand_detail/` + candId
    );
  }

  getInternCandidate(candId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_cand/` + candId
    );
  }

  deleteInternCandidate(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/delete_intern_cand`,
      params
    );
  }

  getInternCandDetailOffer(candID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_mrf_cand_detail_offer/` +
        candID
    );
  }

  addInternCandOffer(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/add_intern_mrf_cand_offer`,
      req
    );
  }

  internMrfNotRequired(params): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/intern_mrf_not_required`,
      params
    );
  }

  getInternCandiateSource(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_candidate_source`
    );
  }

  getInternNewJoiningList(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/intern/get_intern_joining_data`
    );
  }

  joinInternCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/add_intern_cand_joined`,
      req
    );
  }

  rejectInternCandidate(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/add_intern_cand_reject`,
      req
    );
  }

  addInternCandEval(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/add_intern_cand_eval`,
      req
    );
  }

  assignBulkCandMrf(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/talent/mrf/add_bulk_assign_mrf`,
      req
    );
  }

  addInternAssessment(req): Observable<any[]>{
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/intern/add_intern_assessment`,
      req
    );
  }

  sendMailToCandMrf(data): Observable<any>{
    return this.http.post<any>(`${environment.apiUrl}/talent/mrf/send_mail_mrf_to_sm`,data);
  }

  getInternAssessment(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/talent/intern/get_intern_assessment`);
  }

  assessmentDwnld(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/talent/intern/intern_assessment_report`);

  }

  getSelMrfIDs(): Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/talent/mrf/get_mrf_for_assign`);
  }
  
  getAssessmentFile(): Observable<any[]> {
    return this.http.get<any>(`${environment.apiUrl}/talent/intern/get_assesment_file`);

  }
  
  getOverAllRating():Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/talent/intern/get_overall_rating`);
  }

  downloadCandidateAssignDump():Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/mis-reports/candidate_assigned_dump`);
  }

  getCandPFSturcture(mrfId , candID):Observable<any>{
    return this.http.get<any>(`${environment.apiUrl}/talent/mrf/get_cand_pf_structure/` + mrfId + `/` + candID)
  }

}
